import { stringRequiredSchema } from "utils/validation/validationHelpers";
import { array, object } from 'yup';

const attachDocumentSchema = object().shape({

    documents: array().of(object().shape({
        attachment_key: stringRequiredSchema,
        attachment_name: stringRequiredSchema
    })),
});

export default attachDocumentSchema;